const setLocalUserInfo = (userInfo: any) => {
  localStorage.setItem("userInfo", JSON.stringify(userInfo));
};

const getUserInfo = () => {
  const userInfo = localStorage.getItem("userInfo");
  return userInfo ? JSON.parse(userInfo) : null;
};

// Admin Specific User Info
const setAdminUserInfo = (userInfo: any) => {
  localStorage.setItem("adminUserInfo", JSON.stringify(userInfo));
};

const getAdminUserInfo = () => {
  const userInfo = localStorage.getItem("adminUserInfo");
  return userInfo ? JSON.parse(userInfo) : null;
};

const setLocalTheme = (theme: string) => {
  localStorage.setItem("theme", theme);
};

const getTheme = () => {
  const theme = localStorage.getItem("theme");
  return theme ?? "light";
};

const setLocalLanguage = (language: string) => {
  localStorage.setItem("language", language);
};

const getLanguage = () => {
  const language = localStorage.getItem("language");
  return language ?? "en";
};

const setLocalAccessToken = (accessToken: string) => {
  localStorage.setItem("accessToken", accessToken);
};

const getAccessToken = () => {
  const accessToken = localStorage.getItem("accessToken");
  return accessToken ?? null;
};

// Admin Specific Tokens
const setAdminAccessToken = (accessToken: string) => {
  localStorage.setItem("adminAccessToken", accessToken);
};

const getAdminAccessToken = () => {
  const accessToken = localStorage.getItem("adminAccessToken");
  return accessToken ?? null;
};

const setAdminRefreshToken = (refreshToken: string) => {
  localStorage.setItem("adminRefreshToken", refreshToken);
};

const getAdminRefreshToken = () => {
  const refreshToken = localStorage.getItem("adminRefreshToken");
  return refreshToken ?? null;
};

const setLocalRefreshToken = (refreshToken: string) => {
  localStorage.setItem("refreshToken", refreshToken);
};

const getRefreshToken = () => {
  const refreshToken = localStorage.getItem("refreshToken");
  return refreshToken ?? null;
};

const APP_STORAGE_KEYS = [
  "userInfo",
  "adminUserInfo",
  "theme",
  "language",
  "accessToken",
  "refreshToken",
  "adminAccessToken",
  "adminRefreshToken",
];

const clearLocalStorage = () => {
  APP_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
};

export {
  clearLocalStorage,
  getAccessToken, getLanguage, getRefreshToken,
  getTheme, getUserInfo,
  getAdminAccessToken, getAdminRefreshToken, getAdminUserInfo,
  setLocalAccessToken, setLocalLanguage, setLocalRefreshToken,
  setLocalTheme, setLocalUserInfo,
  setAdminAccessToken, setAdminRefreshToken, setAdminUserInfo
};
